import Vue from "vue"
import moment from "moment"

Vue.filter("date", function(date: Date, format: string) {
  if (!format) return moment(date).format("MMMM Do YYYY, h:mm A")
  return moment(date).format(format)
})
